import { HelperContext } from "../../Helper/helper.context";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { helpContextResponsive } from "../../Helper/utils";

import ImgHelpChartWindow from '../../../images/help_context/window_1.png';
import ImgHelpAnalytic from '../../../images/help_context/window_2.png';
import ImgHelpEvent from '../../../images/help_context/window_3.png';

export const ChartWindowHelpContext = ({onClose}) => {
    return (
        <HelperContext 
        onClose={onClose}
        children={
            <div className="pos-relative flex-grow-1">
                <Carousel 
                    className="help-context-carousel"                
                    responsive={helpContextResponsive}
                >
                    <div className="help-context-item">
                        <img src={ImgHelpChartWindow}/>
                    </div>
                    <div className="help-context-item">
                        <img src={ImgHelpAnalytic}/>
                    </div>
                    <div className="help-context-item">
                        <img src={ImgHelpEvent}/>
                    </div>
                </Carousel>
            </div>
        }
    />    
)}